import { connect } from 'react-redux';

import { changeEdditing, closeComments, openComments } from '../../../store/comments';
import { CommentsButton, ICommentsButtonDispatch, ICommentsButtonProps } from './index';

import type { DispatchReduxAction, IState } from '../../../store';

function mapStateToProps(state: IState): ICommentsButtonProps {
  return {
    commentText: state.commentsData.commentText,
    isOpen: state.commentsData.isOpen,
  };
}

function mapDispatchToProps(dispatch: DispatchReduxAction): ICommentsButtonDispatch {
  return {
    changeEdditing: (editing: boolean) => {
      dispatch(changeEdditing(editing));
    },
    closeComments: () => {
      dispatch(closeComments());
    },
    openComments: () => {
      dispatch(openComments());
    },
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CommentsButtonContainer = connect<ICommentsButtonProps, ICommentsButtonDispatch, any>(
  mapStateToProps,
  mapDispatchToProps,
)(CommentsButton);
